


































import { Component, Prop, Vue } from 'vue-property-decorator'
import ShowMore from '../showMore/index2.vue'
import Deliver from '../deliver.vue'
import { ShopTypes } from '../../config'
import { getCustomTag, getRouterQuery, getSelectedCityId } from '@utils/index'
import { namespace, Action } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

import Item from './item.vue'
import Item2 from './item2.vue'
import { intersectionWith, map, uniqWith, filter, includes, sortBy } from 'lodash'
import { Tab, Tabs } from 'vant'
@Component({
  components: {
    Item,
    Item2,
    ShowMore,
    Deliver,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
  },
})
export default class ServiceList extends Vue {
  @Action('getAllCollapselist') getAllCollapselist: ((par: any) => Promise<any>) | undefined
  @shopHomeModule.State shopDetail!: any
  @shopHomeModule.State shopYuer!: boolean
  @shopHomeModule.State shopType!: ShopTypes
  @shopHomeModule.State serviceDetail!: any

  private businessId: any

  //tagList: any[] = [{ text: '全部', value: '' }]
  tagArr: any[] = []

  tabSelect = 0

  PRESHOWNUMS = 12

  isAll = false

  serviceItem: any[] = []

  readonly Children: ShopTypes = ShopTypes.Children
  readonly Education: ShopTypes = ShopTypes.Education
  readonly Ticket: ShopTypes = ShopTypes.Ticket
  readonly Pregnancy: ShopTypes = ShopTypes.Pregnancy

  get tagList() {
    // 小儿纪念品商户不显示分类
    if (this.shopType === ShopTypes.Children) {
      return []
    }
    return [{ text: '全部', value: '' }].concat(this.tagArr)
  }

  /* 小儿纪念品商户的服务显示另一套UI */
  get itemComp() {
    return this.shopType === ShopTypes.Children ? Item2 : Item
  }

  get lastShowIndexs() {
    if (this.shopType === ShopTypes.Children) {
      if (this.isAll || this.serviceItem.length <= this.PRESHOWNUMS) {
        return this.serviceItem.length % 2 == 0 ? [this.serviceItem.length - 2, this.serviceItem.length - 1] : [this.serviceItem.length - 1]
      } else {
        return [this.PRESHOWNUMS - 2, this.PRESHOWNUMS - 1]
      }
    } else {
      if (this.isAll || this.serviceItem.length <= this.PRESHOWNUMS) {
        return [this.serviceItem.length - 1]
      } else {
        return [this.PRESHOWNUMS - 1]
      }
    }
  }

  async created() {
    const businessId = getRouterQuery(this.$route.query.businessId)
    this.businessId = businessId
    if (this.shopDetail.businessType === 24) {
      this.serviceItem = this.serviceDetail?.list?.map((item: any) => {
        return {
          ...item,
          photoItem: item.photoItem ? JSON.parse(item.photoItem)?.[0] : item.photoItem
        }
      })
    } else {
      this.serviceItem = [...this.serviceDetail.list]
    }
    let list = uniqWith(this.serviceItem, (i, oth) => {
      return i.level4CategoryId === oth.level4CategoryId
    })
    list = map(list, (item: any) => item.level4CategoryId)
    let allCollapseList: any[] = []
    if (this.getAllCollapselist) {
      const par: any = {}
      if (this.shopDetail.isself == 1 && this.shopYuer) {
        par.businessId = [this.businessId]
      } else {
        par.storeId = [this.shopDetail && this.shopDetail.storeId]
      }
      allCollapseList = await this.getAllCollapselist({
        ...par,
        collapseType: 1,
        cityId: getSelectedCityId(),
        isSpec: 2,
      })
      allCollapseList = map(allCollapseList, (item: any) => {
        const { level4CategoryId: value, level4Category: text } = item
        return { value: `${value}`, text }
      })
    }
    let arr = intersectionWith(allCollapseList, list, (pre: any, next: any) => pre.value == next)
    if (this.shopYuer) {
      // 育儿按原先的分类逻辑不动
      let resultList = getCustomTag(arr)
      this.tagArr = sortBy(resultList, 'index')
    } else {
      // 成长加取商品四级品类
      this.tagArr = arr
    }
    // 小儿纪念品默认显示10个，其他商户默认显示4个
    if (this.shopType === this.Children) {
      this.PRESHOWNUMS = 10
    } else {
      this.PRESHOWNUMS = 12
    }
  }

  changeTag(index: number) {
     this.$newClickTracker({
      bizType: '127',
      pageLevelId: '121012999',
      clickId: '200009',
      pageParam: {
         popid: this.$route.query.businessId,
         citycode: getSelectedCityId(),
      }
    })
    const { value } = this.tagList[index]
    this.isAll = false
    this.tabSelect = index
    this.serviceItem = value ? filter(this.serviceDetail.list, (item: any) => includes(value, `${item.level4CategoryId}`)) : [...this.serviceDetail.list]
  }

  showMoreService() {
    this.isAll = !this.isAll
  }
}
